import { z } from 'zod';

import { PlanCodeZod } from 'types/zod/plan-code';
import { QInstanceStatusZod } from 'types/zod/qinstance-status';
import { RemainingStepsZod } from 'types/zod/remaining-steps';

export const ClientZod = z.object({
    participantId: z.number(),
    email: z.string().optional(),
    fullName: z.string(),
    estatePlan: z
        .object({
            qInstanceId: z.number(),
            status: z.union([QInstanceStatusZod, z.literal('Update_In_Progress')]),
            planType: PlanCodeZod,
            completeStatus: z.record(RemainingStepsZod, z.boolean()),
            section: z.string(),
            invoiceSent: z.boolean(),
        })
        .optional(),
    giftTrusts: z.array(
        z.object({
            qInstanceId: z.number(),
            status: QInstanceStatusZod,
            isSigned: z.boolean(),
        }),
    ),
    lastActivityTimestamp: z.number(),
    awsId: z.string().optional(),
    advisorParticipantId: z.number().optional(),
    isHandoverCommitted: z.boolean().optional(),
    createdByUserId: z.number().optional(),
    hasGeneratedDocs: z.boolean().optional(),
});

export type Client = z.infer<typeof ClientZod>;
